/* eslint-disable */
import { Component, Injector, ViewChild } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import { NgRedux } from '@angular-redux/store';
import { SelectOptionsService } from '../../../shared/services/selectoptions.service';
import { DTMService } from '../../../shared/services/dtm.service';
import LogRocket from 'logrocket';
import styles from './submit-application.component.scss';
import { whichEnv } from '../../../shared/helpers/whichEnv';

import { LogRocketTrackerService } from '../../../shared/services/log-rocket-tracker.service';

@Component({
  selector: 'submit-application',
  template: require('./submit-application.component.html'),
  styles: [styles],
})
export class SubmitApplicationComponent extends BaseRoute {
  @ViewChild('focusItem') focusItem;

  constructor(
    injector: Injector,
    optionsService: SelectOptionsService,
    dtm: DTMService,
    redux: NgRedux,
    logRocketTracker: LogRocketTrackerService
  ) {
    super(injector);
    this.optionsService = optionsService;
    this.dtm = dtm;
    this.submitError = false;
    this.redux = redux;
    this.logRocketTracker = logRocketTracker;
    this.hasFocusedItem = false;

    this.isStreamline = false;
    this.depositAccounts = this.route.data.value.depositAccounts;
    if (this.depositAccounts && this.depositAccounts.length > 0) {
      this.appActions.setData('Streamline.accounts', this.depositAccounts);
      this.flowManager.hasDepositAccounts = true;
      if (this.depositAccounts.length > 0) {
        this.isStreamline = true;
      }
    }
  }

  ngAfterViewChecked() {
    if (
      this.flowManager.isSubmitting &&
      this.focusItem &&
      !this.hasFocusedItem
    ) {
      this.focusItem.nativeElement.focus();
      this.hasFocusedItem = true;
    } else if (!this.flowManager.isSubmitting) {
      this.hasFocusedItem = false;
    }
  }

  ngOnInit() {
    // Reset Agreements and Signatures
    this.setAgreements(false);
    this.clearSignatures();

    const applyForMargin = this.flowManager.getApplyForMargin();
    const applyForOption = this.flowManager.getApplyForOption();
    const agreements = this.form.inputs.accordion.agreements;
    this.enrollInFPSL = this.flowManager.getEnrollInFPSL();

    if (applyForMargin !== true) {
      agreements.marginAgreement.showUp = false;
    }

    if (applyForOption !== true) {
      agreements.optionAgreement.showUp = false;
      agreements.optionRisksAgreement.showUp = false;
      agreements.optionWritersAgreement.showUp = false;
    }

    if (this.flowManager.isIra !== true) {
      agreements.iraAgreement.showUp = false;
      agreements.iraRothAgreement.showUp = false;
    }

    if (this.enrollInFPSL !== true) {
      agreements.fpslAgreement.showUp = false;
    }
  }

  ngAfterViewInit() {
    // 41P Experian
    window.nsp.afn(null);
  }

  getAccountHolderName(info) {
    let firstName = 'Account';
    let middleInitial = null;
    let lastName = 'Holders Name';

    if (info !== null && info !== undefined) {
      firstName = info.firstName || firstName; // Just incase the info is there, but the keys are still missing
      lastName = info.lastName || lastName;
      middleInitial = info.middleInitial;
    }

    return `${firstName} ${middleInitial || ''}${
      middleInitial ? ' ' : ''
    }${lastName}`;
  }

  updateOptionValue(event) {
    if (event === 'agreementsConsent') {
      this.setAgreements(true);
      this.form.inputs.submitBtnHelper.showUp = true;
      this.form.buttons.inputs.next.showUp = true;
    }
  }

  btnClick(e) {
    const logAction = e && e.action ? e.action : '';
    this.logRocketTracker.track(
      `submit-application.component btnClick() action`,
      logAction
    );
    if (e.action === 'next' && !this.flowManager.isSubmitting) {
      this.logRocketTracker.track(
        "submit-application.component btnClick() inside check for 'next'"
      );
      this.attemptSubmitApplication();
      return;
    }

    this.handleClick(e);
  }

  soapRequest() {
    this.appProxy.submitSOAPRequest(this.appData, (resp) => {
      // console.log('response back from 41p', resp);
    });
  }

  setAgreements(bool) {
    if (bool) {
      const date = new Date();
      const dd = (date.getDate() < 10 ? '0' : '') + date.getDate();
      const mm = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
      const yyyy = date.getFullYear();
      this.today = `${mm}/${dd}/${yyyy}`;
    }
    const agreements = Object.values(
      this.form.inputs.accordion.agreements
    ).filter((agmt) => agmt.showUp === true);
    agreements.forEach((agmt) => {
      const path = `ApplicationInformation.${agmt.id}`;
      if (bool) {
        this.appActions.setData(path, this.today);
      } else {
        this.appActions.deleteData(path);
      }
    });
  }

  clearSignatures() {
    this.appActions.deleteData('ApplicationInformation.signature');
    this.appActions.deleteData('ApplicationInformation.jointAccountSignature');
  }

  async attemptSubmitApplication() {
    this.flowManager.isSubmitting = true;
    // Check the status of the GUID to prevent duplicate submissions
    const { data: submissionStatus } =
      await this.appProxy.checkSubmissionStatus();
    if (submissionStatus === 'error') {
      this.submitError = true;
      this.router.navigate(['error-submitting-app'], {
        queryParamsHandling: 'preserve',
      });
      return;
    } else if (submissionStatus === 'processing') {
      // Need to long poll and wait till a reponse of error or completed
      setTimeout(() => {
        this.attemptSubmitApplication();
      }, 2000);
    } else if (submissionStatus === 'complete') {
      const resp = await this.appProxy.getSubmissionResponse();
      this.processApplication(resp);
    } else {
      //No Guid is found so submit the application
      this.submitApplication();
    }
  }

  submitApplication() {
    // For Primary Account Holder signature
    const yourInfo = this.appActions.getData('YourInformation');
    const primaryHolderName = this.getAccountHolderName(yourInfo);
    const isJoint = this.flowManager.getAccountType() === 'select-joint';

    this.appActions.setData(
      'ApplicationInformation.signature.name',
      primaryHolderName
    );
    this.appActions.setData(
      'ApplicationInformation.signature.date',
      this.today
    );
    if (isJoint) {
      // For Joint Account Holder signature
      const jointInfo = this.appActions.getData('JointAccountInformation');
      const secondaryHolderName = this.getAccountHolderName(jointInfo);
      this.appActions.setData(
        'ApplicationInformation.jointAccountSignature.name',
        secondaryHolderName
      );
      this.appActions.setData(
        'ApplicationInformation.jointAccountSignature.date',
        this.today
      );
    }

    // Remove trusted contact from the redux store, if it was set but user clicked on skip button, so it won't be sent in the submit payload
    if (this.flowManager.isTrustedContactSkipped) {
      this.appActions.deleteData('TrustedContact');
    }

    // Get state
    const applicationData = this.appActions.getState();
    applicationData.ApplicationInformation.guid = applicationData.guid;

    this.appData = this.buildPayload();
    applicationData.appData = this.appData;

    this.logRocketTracker.track(
      'submit-application.component submitApplication()',
      { guid: applicationData.guid || 'N/A' }
    );

    //this.flowManager.isSubmitting = true;

    this.appProxy.submitApplication(applicationData).then(async (resp) => {
      if (resp.statusCode === 408) {
        this.attemptSubmitApplication();
      } else {
        this.processApplication(resp);
      }
    });
  }

  processApplication(resp) {
    const applicationData = this.appActions.getState();
    const guid = (applicationData.ApplicationInformation.guid =
      applicationData.guid);
    const logData = {
      guid: guid,
      status: resp.status || '',
    };
    this.logRocketTracker.track(
      'submit-application.component this.appProxy.submitApplication callback',
      logData
    );

    if (resp.status === 'WTF') {
      this.flowManager.requestId = guid;
      this.dtm.triggerEventPurchaseComplete('rejected');
      this.router.navigate(['error-submitting-app'], {
        queryParamsHandling: 'preserve',
      });
    }
    this.flowManager.isSubmitting = false;
    if (resp && resp.result) {
      this.logRocketTracker.track(
        'submit-application.component this.appProxy.submitApplication callback if resp.result'
      );
      const result = resp.result;
      // Set sciVantageId on LogRocket session if user is not authenticated
      if (!whichEnv.isDevLike && !this.flowManager.isAuthed && result.userName) {
        LogRocket.identify(guid, { name: result.userName });
      }

      if (result.errorCode) {
        this.logRocketTracker.track(
          'submit-application.component this.appProxy.submitApplication callback if resp.result',
          { errorCode }
        );
      }

      // TODO: is this still valid??
      // Handle Blocked SSN
      if (result.errorCode === 'WFL') {
        this.submitError = true;
        // Handle all non error codes
      } else if (result.errorCode == null) {
        this.submitError = false;
        this.flowManager.applicationId = result.applicationId;
        this.flowManager.requestId = result.requestId;
        this.flowManager.accountStatus = result.accountStatus;
        this.logRocketTracker.track(
          'submit-application.component this.appProxy.submitApplication callback StepCompleted.submitApp'
        );
        this.appActions.setData('StepCompleted.submitApp', true);
        if (result.accountStatus === 'OOW') {
          this.logRocketTracker.track(
            'submit-application.component this.appProxy.submitApplication callback application completed',
            { routedTo: 'pending-app-cip' }
          );
          this.router.navigate(['pending-app-cip'], {
            queryParamsHandling: 'preserve',
          });
          return;
        }

        if (result.accountStatus === 'PROCESSED') {
          const currentAppType = this.flowManager.getAppType() === 'tks' ? 'SD' : 'Robo';
          if (window.allytm) {
            window.allytm.event("customEvent", {
              name: "olaApplicationApproved",
              attr: { currentAppType },
            });
          }
          this.flowManager.acmGuid = result.acmGuid; // This doesn't exist in result?
          this.appActions.setData('DepositFunds.to', result.accountNumber);
          this.soapRequest();
          this.logRocketTracker.track(
            'submit-application.component this.appProxy.submitApplication callback dtm.triggerEventPurchaseComplete',
            { value: 'approved' }
          );
          this.dtm.triggerEventPurchaseComplete('approved');
          if (this.isStreamline) {
            this.logRocketTracker.track(
              'submit-application.component this.appProxy.submitApplication callback application completed',
              { routedTo: 'funding-choices-streamline' }
            );
            this.router.navigate(['funding-choices-streamline'], {
              queryParamsHandling: 'preserve',
            });
          } else {
            this.logRocketTracker.track(
              'submit-application.component this.appProxy.submitApplication callback application completed',
              { routedTo: 'funding-choices' }
            );
            this.router.navigate(['funding-choices'], {
              queryParamsHandling: 'preserve',
            });
          }
        } else if (
          result.accountStatus === 'FAIL' ||
          result.accountStatus === 'REJECTED' ||
          result.accountStatus === 'UNDER_AGE'
        ) {
          // FAIL status might have just been an OLA Service thing - need to check
          this.soapRequest();
          this.logRocketTracker.track(
            'submit-application.component this.appProxy.submitApplication callback dtm.triggerEventPurchaseComplete',
            { value: 'rejected' }
          );
          this.dtm.triggerEventPurchaseComplete('rejected');
          this.logRocketTracker.track(
            'submit-application.component this.appProxy.submitApplication callback application completed',
            { routedTo: 'rejected-app' }
          );
          this.router.navigate(['rejected-app'], {
            queryParamsHandling: 'preserve',
          });
        } else if (
          result.accountStatus === 'MISSING_DATA' ||
          result.accountStatus === 'ERROR' ||
          result.accountStatus === 'EXCEPTION'
        ) {
          this.logRocketTracker.track(
            'submit-application.component this.appProxy.submitApplication callback application completed',
            { routedTo: 'error-submitting-app' }
          );
          this.router.navigate(['error-submitting-app'], {
            queryParamsHandling: 'preserve',
          });
          // } else if (result.accountStatus === 'DOCUMENTS_REQUESTED') {
        } else if (resp.documentsRequested && resp.documentsRequested.length) {
          this.appActions.setData('DocumentUploader.id', resp.id);
          this.appActions.setData(
            'DocumentUploader.applicationId',
            resp.result.applicationId
          );
          this.logRocketTracker.track(
            'submit-application.component this.appProxy.submitApplication callback dtm.triggerEventPurchaseComplete',
            { value: 'pended' }
          );
          this.dtm.triggerEventPurchaseComplete('pended');
          this.logRocketTracker.track(
            'submit-application.component this.appProxy.submitApplication callback application completed',
            { routedTo: 'document-uploader' }
          );
          this.router.navigate(['document-uploader'], {
            queryParamsHandling: 'preserve',
          });
        } else {
          this.soapRequest();
          this.logRocketTracker.track(
            'submit-application.component this.appProxy.submitApplication callback dtm.triggerEventPurchaseComplete',
            { value: 'pended' }
          );
          this.dtm.triggerEventPurchaseComplete('pended');
          this.logRocketTracker.track(
            'submit-application.component this.appProxy.submitApplication callback application completed',
            { routedTo: 'pending-app' }
          );
          this.router.navigate(['pending-app'], {
            queryParamsHandling: 'preserve',
          });
        }
        // Catch for error codes, may use generic error message in future
      } else {
        this.soapRequest('Deny');
        this.flowManager.requestId = guid;
        this.logRocketTracker.track(
          'submit-application.component this.appProxy.submitApplication callback dtm.triggerEventPurchaseComplete',
          { value: 'rejected' }
        );
        this.dtm.triggerEventPurchaseComplete('rejected');
        this.logRocketTracker.track(
          'submit-application.component this.appProxy.submitApplication callback application completed',
          { routedTo: 'error-submitting-app' }
        );
        this.router.navigate(['error-submitting-app'], {
          queryParamsHandling: 'preserve',
        });
      }
    } else {
      this.logRocketTracker.track(
        'submit-application.component this.appProxy.submitApplication callback if resp.result else'
      );
      this.flowManager.requestId = guid;
      this.logRocketTracker.track(
        'submit-application.component this.appProxy.submitApplication callback dtm.triggerEventPurchaseComplete',
        { value: 'rejected' }
      );
      this.dtm.triggerEventPurchaseComplete('rejected');
      this.logRocketTracker.track(
        'submit-application.component this.appProxy.submitApplication callback application completed',
        { routedTo: 'error-submitting-app' }
      );
      this.router.navigate(['error-submitting-app'], {
        queryParamsHandling: 'preserve',
      });
    }
  }

  buildPayload() {
    const reduxState = this.redux.getState();
    const yourInformation = reduxState.applicationStore.YourInformation;
    const personalInformation = reduxState.applicationStore.PersonalInformation;
    const stateCodeVal = personalInformation.address.state;

    let address = personalInformation.address.street;
    if (personalInformation.address.street2 != null) {
      address = `${address} ${personalInformation.address.street2}`;
    }

    const hdim = document.getElementById('user_prefs2').value;

    const appData = {
      fingerPrint: window.nsp.cfn('ppm') || null,
      hdim,
      firstName: yourInformation.firstName,
      lastName: yourInformation.lastName,
      email: yourInformation.email,
      telephone: personalInformation.mobilePhone,
      phoneLocationType: '9',
      address: address,
      city: personalInformation.address.city,
      postalCode: personalInformation.address.zip,
      state: this.optionsService.getCodeName('state', stateCodeVal),
      stateCode: stateCodeVal,
      accountType:
        reduxState.applicationStore.ApplicationInformation.accountType,
      optInFpsl: this.enrollInFPSL ? 1 : 0,
      passFail: 'Not Available',
      loginType: '',
      country: 'united states', // not used by BE/MW teams anymore
    };

    if (appData.accountType === 'select-joint') {
      const jointInfo = this.appActions.getData('JointAccountInformation', {});
      let mailAddress = jointInfo.differentAddressFromPrimary
        ? jointInfo.mailingAddress
        : personalInformation.address;
      if (
        jointInfo.differentAddressFromPrimary &&
        jointInfo.mailingAddress.street2 != null
      ) {
        mailAddress = `${mailAddress} ${jointInfo.mailingAddress.street2}`;
      }

      appData.jointApplicant = {
        firstName: jointInfo.firstName,
        lastName: jointInfo.lastName,
        email: jointInfo.email,
        telephone: jointInfo.mobilePhone,
        phoneLocationType: '9',
        address: mailAddress.street,
        city: mailAddress.city,
        state: this.optionsService.getCodeName('state', mailAddress.state),
        stateCode: mailAddress.state,
        postalCode: mailAddress.zip,
        country: 'united states', // not used by BE/MW teams anymore
      };
    }

    return appData;
  }
}
